const { gql } = require('@apollo/client');

export const QUERY_CMS_LANDLORD_CONTRACT = gql`
  query CMS_ContractView(
    $pageNumber: PositiveInteger
    $pageSize: PositiveInteger
    $signedDateStart: Date
    $signedDateEnd: Date
    $landlordSlugs: [String!]
    $statuses: [ContractStatus!]
    $sortBy: ContractSortBy
    $sortDirection: SortDirection
    $levels: [PropertyContractLevel]
  ) {
    contracts(
      pageSize: $pageSize
      pageNumber: $pageNumber
      signedDateStart: $signedDateStart
      signedDateEnd: $signedDateEnd
      landlordSlugs: $landlordSlugs
      statuses: $statuses
      sortBy: $sortBy
      sortDirection: $sortDirection
      levels: $levels
    ) {
      pageInfo {
        numPages
      }
      totalCount
      edges {
        node {
          id
          createdAt
          effectiveFrom
          effectiveTo
          landlord {
            name
            id
            slug
          }
          updatedAt
          signedDate
          files {
            id
            name
            source
            updatedAt
            contentType
            contractId
            createdAt
          }
          properties {
            id
            name
          }
        }
      }
    }
  }
`;
